import React from "react";
import PropTypes from "prop-types";
import * as Icon from "./Icons";

export const Infobar = props => {
  const { text, tag, color, ...otherProps } = props;

  return (
    <div
      className={`rounded bg-${color}-darkest text-center py-4 lg:px-4 mb-4`}
      {...otherProps}
    >
      <div
        className={`p-2 bg-${color}-darker items-center text-${color}-lightest leading-none lg:rounded-full flex lg:inline-flex`}
        role="alert"
      >
        {tag && (
          <span
            className={`flex rounded-full bg-${color} uppercase px-2 py-1 text-xs font-bold`}
          >
            {tag}
          </span>
        )}
        <span className="font-semibold mx-2 text-left flex-auto">{text}</span>
        <Icon.RightArrow />
      </div>
    </div>
  );
};

Infobar.defaultProps = {
  color: "blue"
};

Infobar.propTypes = {
  text: PropTypes.string.isRequired,
  tag: PropTypes.string,
  color: PropTypes.string
};

export const Basic = props => {
  const {
    main,
    text,
    details,
    color,
    showCloseButton,
    centered,
    ...otherProps
  } = props;

  return (
    <div
      className={`bg-${color}-lightest ${centered &&
        "text-center"} border border-${color}-light text-${color}-dark px-4 py-3 rounded relative my-4`}
      role="alert"
      {...otherProps}
    >
      <strong className="font-bold">{main}&nbsp;</strong>
      <span className="block sm:inline">{text}</span>
      {details && <p className="mt-4 p-2 text-justify">{details}</p>}
      {showCloseButton && (
        <span className="absolute pin-t pin-b pin-r px-4 py-3">
          <Icon.Cross />
        </span>
      )}
    </div>
  );
};

Basic.defaultProps = {
  main: "Alert!",
  color: "blue",
  showCloseButton: false,
  centered: false
};

Basic.propTypes = {
  main: PropTypes.string,
  text: PropTypes.string.isRequired,
  color: PropTypes.string,
  details: PropTypes.string,
  showCloseButton: PropTypes.bool,
  centered: PropTypes.bool
};



// WEBPACK FOOTER //
// ./src/components/Alerts.js